import { render, staticRenderFns } from "./AddKeeper.vue?vue&type=template&id=65bb224a"
import script from "./AddKeeper.vue?vue&type=script&lang=js"
export * from "./AddKeeper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports